import type { InventoryCostCheck } from './inventory-cost-check.js';

export const INVENTORY_COST_CHECK_LABELS: Record<InventoryCostCheck, string> = {
  FAR: 'far from standard cost',
  UNPRICED: 'not costed',
  NO_STANDARD: 'with no standard cost',
};
